module.exports = __webpack_public_path__ + "img/logo priority-01.a459150b.png";